// extracted by mini-css-extract-plugin
export default {"form":"campaignForm_form__B18Hv","title":"campaignForm_title__hisPr","btn":"campaignForm_btn__bngvf"};